import { render, staticRenderFns } from "./LoginNotice.vue?vue&type=template&id=09a23230&"
import script from "./LoginNotice.vue?vue&type=script&lang=ts&"
export * from "./LoginNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports